import React from 'react';

import { BaseColorKeys, PureColorKeys } from '../../theme';
import { StudentState } from '../../types/common';
import { STUDENT_STATES } from '../../utils/common/constants';
import Chip, { ChipProps } from '../Chip';

export interface StudentStateChipProps extends ChipProps {
  state: StudentState,
  color?: PureColorKeys | BaseColorKeys,
}

const StudentStateChip = ({ state, color, ...rest }: StudentStateChipProps) => (
  <Chip
    label={STUDENT_STATES[state].label}
    color={color || STUDENT_STATES[state].colorKey}
    variant="filled"
    {...rest}
  />
);

export default StudentStateChip;
